module.exports = __webpack_public_path__ + "img/landscape-sea-hills.cadcf191.jpg";